<template>
  <div class="container-xl pages" :class="s.container">
    <div class="pages_top">
      <p class="pages_top_title">{{ policy.title }}</p>
    </div>
    <div>
      <div class="pages_section_description">{{ policy.description }}</div>
    </div>

    <section
      class="pages_section"
      v-for="section in policy.sections"
      :key="section">
      <div class="pages_section_title">{{ section.titles[0] }}</div>
      <div
        class="pages_section_description"
        v-for="row in section.descriptions"
        :key="row">{{ row }}</div>

      <ol :class="{numlists: section.numlists && section.numlists.length > 1}">
        <li v-for="numlist in section.numlists"
          :key="numlist">
          <p
            v-if="numlist.title && numlist.title.length">{{ numlist.title[0] }}</p>
          <p>{{ numlist.description }}</p>

          <ol
            class="bracketslists"
            v-if="numlist.bracketslists && numlist.bracketslists.length > 1">
            <li
              v-for="bracketslist in numlist.bracketslists"
              :key="bracketslist">
              <p v-if="bracketslist.title && bracketslist.title.length">{{ bracketslist.title[0] }}</p>
              <p v-for="description in bracketslist.descriptions"
              :key="description">{{ description }}</p>

              <ol class="desclists">
                <li
                  v-for="detail in bracketslist.details"
                  :key="detail">
                  <p>{{ detail }}</p></li>
              </ol>
            </li>
          </ol>

          <div v-if="numlist.bracketslists && numlist.bracketslists.length < 2">
            <ol class="desclists">
              <li
                v-for="detail in numlist.bracketslists[0].details"
                :key="detail">
                <p>{{ detail }}</p></li>
            </ol>
          </div>
        </li>
      </ol>
    </section>
    <p v-html="policy.date"></p>
    <Spacer :y="3" />
    <button :class="s.backButton" @click="this.$router.push('/');">TOPページに戻る</button>
    <Spacer :y="3" />
  </div>
</template>

<script>
import policy from '@/data/policy.yml';
import {
  Spacer,
} from '@/components/parts';

export default {
  name: 'policy',
  components: {
    Spacer,
  },
  created() {
    // 一番上までスクロール
    window.scrollTo(0, 0);
  },
  data() {
    return {
      policy,
    };
  },
};
</script>

<style lang="scss" module="s">
.container {
  width: 100%;
  max-width: 880px;
  margin: 150px auto;
  padding: 0 40px;
  @media (max-width: 576px) {
    margin-top: 70px;
    padding: 0 30px;
  }
}
.backButton {
  background-color: transparent;
  color: #333;
  font-size: 20px;
  padding: 10px 30px;
  border: 2px solid #333;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  justify-self: center;
  text-align: center;
}
</style>
